import React from 'react'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  changePage
} from '../../../action/VodAction';
import MovieList from '../movie-list/movieList'
import GenreList from './genre-list/genreList'

class Genre extends React.Component {
  getGenrePage = () => {
    let flag = false, genreObj = null
    if (this.props.categoryOrder) {
      this.props.categoryOrder.map((iterator, index) => {
        if (this.props.genrePageNumber === iterator.name) {
          flag = true
          genreObj = {
            name: iterator.name,
            index: iterator.id
          }
        }
      })
      if (flag) {
        return <MovieList category={genreObj} />
      }
      else {
        return <GenreList />
      }
    }
  }

  render() {
    return (
      <div>
        {this.getGenrePage()}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    stringConst: state.store.home.stringConst,
    genrePageNumber: state.store.vod.genre.currentGenrePage,
    categoryOrder: state.store.vod.VODData ?
      state.store.vod.VODData.channelCategoryOrder : null
  }
}

export default connect(
  mapStateToProps, {
    changePage
  }
)(Genre);